export type BackgroundOption = {
  backgroundId: string;
  label: string;
  profileId: string;
  originFeatId: string;
  description: string;
  languageChoicePool: string[];
  languageChoiceCount: number;
  relevantAbilities?: string[];
  equipmentSupport: "supported" | "deferred";
  equipmentNote?: string;
};

export async function fetchBackgrounds(): Promise<BackgroundOption[]> {
  const res = await fetch("/api/backgrounds");

  if (!res.ok) {
    throw new Error(`Failed to fetch backgrounds: ${res.statusText}`);
  }

  return res.json() as Promise<BackgroundOption[]>;
}
